/* eslint-disable global-require */
/* eslint-disable no-underscore-dangle */
import { applyMiddleware, legacy_createStore as createStore } from 'redux';
import { createWrapper } from 'next-redux-wrapper';
import {
  createStateSyncMiddleware,
  initMessageListener,
} from 'redux-state-sync';
import { withExtraArgument } from 'redux-thunk';

import reducers from '@reducers';
import {
  BASKET_ADD_PRODUCT,
  BASKET_REMOVE_PRODUCT,
  BASKET_UPDATE_PRODUCT,
  CLEAR_BASKET,
  GET_BASKET_CALCULATIONS_REQUEST,
  GET_BASKET_CALCULATIONS_SUCCESS,
  GET_BASKET_CALCULATIONS_FAILURE,
  SUBMIT_ORDER_SUCCESS,
} from '@actions/basket';
import {
  ADD_FAVORITE_SUCCESS,
  FAVORITE_UNAUTHENTICATED,
  UNFAVORITE_SUCCESS,
  UNFAVORITE_UNAUTHENTICATED,
} from '@actions/favorites';

import { isBrowser } from '@utils/environmentCheck';
import { getRequestInstance } from '@utils/request';

const bindMiddleware = middleware => {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('@redux-devtools/extension');

    const composeEnhancers = composeWithDevTools({ trace: true });

    return composeEnhancers(applyMiddleware(...middleware));
  }

  return applyMiddleware(...middleware);
};

const makeConfiguredStore = (reducer, requestInstance, ...middlewares) =>
  createStore(
    reducer,
    bindMiddleware([withExtraArgument(requestInstance), ...middlewares]),
  );

export const makeStore = args => {
  const requestInstance = getRequestInstance(args?.ctx);

  if (!isBrowser) {
    return makeConfiguredStore(reducers, requestInstance);
  }

  // we need it only on client side
  const { persistStore, persistReducer } = require('redux-persist');
  const storage = require('redux-persist/lib/storage').default;

  const persistConfig = {
    key: 'nextjs',
    whitelist: ['favorites'],
    storage,
  };

  const persistedReducer = persistReducer(persistConfig, reducers);
  const store = makeConfiguredStore(
    persistedReducer,
    requestInstance,
    createStateSyncMiddleware({
      channel: `chicoree_${window.location.host}`,
      whitelist: [
        BASKET_ADD_PRODUCT,
        BASKET_REMOVE_PRODUCT,
        BASKET_UPDATE_PRODUCT,
        CLEAR_BASKET,
        GET_BASKET_CALCULATIONS_REQUEST,
        GET_BASKET_CALCULATIONS_SUCCESS,
        GET_BASKET_CALCULATIONS_FAILURE,
        SUBMIT_ORDER_SUCCESS,
        UNFAVORITE_SUCCESS,
        ADD_FAVORITE_SUCCESS,
        FAVORITE_UNAUTHENTICATED,
        UNFAVORITE_UNAUTHENTICATED,
      ],
    }),
  );

  store.__persistor = persistStore(store);

  initMessageListener(store);

  return store;
};

export const wrapper = createWrapper(makeStore, { debug: false });
